import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Locality } from './address.types';

@Injectable({
  providedIn: 'root',
})

export class AddressApiService {
  constructor(private httpClient: HttpClient) {}

  fetchToponym(city: string, localityId: string): Observable<string> {
    let parameters = new HttpParams();
    parameters = parameters.append('city', city);
    parameters = parameters.append('localityId', localityId);
    return this.httpClient.get<string>('/api/toponym-path', {
      params: parameters,
    });
  }

  fetchToponyms(city: string): Observable<Locality[]> {
    let parameters = new HttpParams();
    parameters = parameters.append('city', city);
    return this.httpClient.get<Locality[]>('/api/toponyms', {
      params: parameters,
    });
  }
}
